// ===========================================================
// DROPSHIPPER MODULE - Fixed for older browsers
// ===========================================================

(function() {
  'use strict';

  const MODULE = {
    dropshippers: [],
    isLoading: false,
    hasLoaded: false,
    reportData: null,
    currentDropshipperId: null
  };

  const EXCHANGE_RATES = {
    'USD': 3.676, 'EUR': 3.985, 'GBP': 4.67, 'SAR': 0.979,
    'QAR': 1.006, 'OMR': 9.54, 'BHD': 9.74, 'AED': 1
  };

  // ===========================================================
  // CURRENCY UTILITIES
  // ===========================================================

  function convertToAED(amount, fromCurrency) {
    const num = parseFloat(amount) || 0;
    if (!fromCurrency || fromCurrency === 'AED') return num;
    const rate = EXCHANGE_RATES[fromCurrency.toUpperCase()];
    return rate ? num * rate : num;
  }

  function formatPrice(amount, currency) {
    currency = currency || 'AED';
    return currency + ' ' + parseFloat(amount).toFixed(2);
  }

  function getOrderCurrency(order) {
    return order.currency || order.presentment_currency || 'AED';
  }

  // ===========================================================
  // HELPER: Get email from order (checks multiple fields)
  // ===========================================================

  function getOrderEmail(order) {
    if (!order) return '';
    
    var possibleFields = [
      order.email,
      order.customer_email,
      (order.customer && order.customer.email),
      (order.customer && order.customer.customer_email),
      (order.billing_address && order.billing_address.email),
      (order.shipping_address && order.shipping_address.email),
      order.contact_email
    ];
    
    for (var i = 0; i < possibleFields.length; i++) {
      var field = possibleFields[i];
      if (field && typeof field === 'string') {
        return field.toLowerCase().trim();
      }
    }
    return '';
  }

  // ===========================================================
  // CONFIG PARSING
  // ===========================================================

  function parseConfig(note) {
    var config = {
      brands: {},
      default: { type: 'percentage', value: 10 },
      shipping: { freeThreshold: 0, defaultCost: 0, useActual: true }
    };

    if (!note) return config;

    var parts = note.split('|');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      var keyValue = part.split(':');
      if (keyValue.length < 2) continue;
      
      var key = keyValue[0] ? keyValue[0].trim() : '';
      var value = keyValue[1] ? keyValue[1].trim() : '';
      
      if (!key || !value) continue;

      var k = key.toUpperCase();

      if (k === 'BRAND') {
        var brandDisc = value.split('=');
        if (brandDisc.length >= 2) {
          var brandName = brandDisc[0].trim();
          var discStr = brandDisc[1];
          var isFixed = discStr.toLowerCase().indexOf('fixed') !== -1;
          var numValue = parseFloat(discStr.replace(/[^0-9.]/g, '')) || 10;
          var cleanBrand = brandName.replace(/\s+/g, ' ');
          config.brands[cleanBrand] = {
            type: isFixed ? 'fixed' : 'percentage',
            value: numValue
          };
        }
      }
      else if (k === 'DEFAULT') {
        var isFixedDefault = value.toLowerCase().indexOf('fixed') !== -1;
        var numValueDefault = parseFloat(value.replace(/[^0-9.]/g, '')) || 10;
        config.default = {
          type: isFixedDefault ? 'fixed' : 'percentage',
          value: numValueDefault
        };
      }
      else if (k === 'SHIPPING') {
        var v = value.toLowerCase();
        if (v === 'actual') {
          config.shipping = { freeThreshold: 0, defaultCost: 0, useActual: true };
        } else if (v.indexOf('free=') === 0) {
          var freeVal = parseFloat(v.split('=')[1]) || 500;
          config.shipping = { freeThreshold: freeVal, defaultCost: 0, useActual: false };
        } else if (v.indexOf('fixed=') === 0) {
          var fixedVal = parseFloat(v.split('=')[1]) || 0;
          config.shipping = { freeThreshold: 0, defaultCost: fixedVal, useActual: false };
        }
      }
    }

    return config;
  }

  function getBrandDiscount(dropshipper, brandName) {
    if (!brandName) return dropshipper.defaultDiscount;
    
    var clean = brandName.trim().replace(/\s+/g, ' ');
    var brands = dropshipper.brandDiscounts || {};
    
    if (brands[clean]) return brands[clean];
    
    var keys = Object.keys(brands);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].toLowerCase() === clean.toLowerCase()) {
        return brands[keys[i]];
      }
    }
    
    var noSpace = clean.replace(/\s/g, '');
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].replace(/\s/g, '').toLowerCase() === noSpace.toLowerCase()) {
        return brands[keys[i]];
      }
    }
    
    return dropshipper.defaultDiscount;
  }

  // ===========================================================
  // SHIPPING CALCULATION
  // ===========================================================

  function calculateShipping(order, dropshipper) {
    var address = order.shipping_address || {};
    var city = (address.city || '').toLowerCase().trim();
    var country = (address.country_code || '').toUpperCase();
    
    var items = order.line_items || [];
    var weight = 0;
    var subtotal = 0;
    
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      weight += ((item.grams || 0) * (item.quantity || 1));
      subtotal += (convertToAED(item.price, getOrderCurrency(order)) * (item.quantity || 1));
    }

    if (country === 'AE' || country === 'UAE') {
      if (city.indexOf('dubai') !== -1 && weight <= 5000) return { cost: 30, method: 'Same Day (Dubai)' };
      if (subtotal >= 400) return { cost: 0, method: 'Express Free' };
      if (weight <= 9000) return { cost: 15, method: 'Express' };
      if (weight <= 15000) return { cost: 30, method: 'Extra Long' };
      return { cost: 50, method: 'Heavy (Contact)' };
    }
    
    if (weight <= 9000) return { cost: 150, method: 'Intl Express' };
    if (weight <= 15000) return { cost: 400, method: 'Intl Standard' };
    return { cost: 600, method: 'Intl Heavy (Contact)' };
  }

  // ===========================================================
  // DATA LOADING
  // ===========================================================

  function loadDropshippers() {
    if (MODULE.isLoading || MODULE.hasLoaded) return;
    MODULE.isLoading = true;

    try {
      var tag = (GLOBAL_CONFIG && GLOBAL_CONFIG.DROPSHIPPER_TAG) || 'fishondropshipper';
      
      console.log('🔍 Total orders in MASTER_DB:', (MASTER_DB.orders && MASTER_DB.orders.length) || 0);
      console.log('🔍 Total customers in MASTER_DB:', (MASTER_DB.customers && MASTER_DB.customers.length) || 0);

      if (MASTER_DB.orders && MASTER_DB.orders.length > 0) {
        var sampleOrder = MASTER_DB.orders[0];
        console.log('📋 Sample order structure:', {
          name: sampleOrder.name,
          email: sampleOrder.email,
          customer_email: sampleOrder.customer_email,
          customer_obj: sampleOrder.customer,
          contact_email: sampleOrder.contact_email
        });
      }

      var customers = MASTER_DB.customers || [];
      var filteredCustomers = [];
      
      for (var i = 0; i < customers.length; i++) {
        var c = customers[i];
        if (!c.tags) continue;
        
        var tags = Array.isArray(c.tags) ? c.tags : c.tags.toString().split(',');
        var hasTag = false;
        
        for (var j = 0; j < tags.length; j++) {
          if (tags[j].trim().toLowerCase() === tag) {
            hasTag = true;
            break;
          }
        }
        
        if (hasTag) filteredCustomers.push(c);
      }

      MODULE.dropshippers = filteredCustomers.map(function(c) {
        var config = parseConfig(c.note);
        var rawSpent = parseFloat(c.total_spent) || 0;
        
        var customerEmail = (c.email || '').toLowerCase().trim();
        var orders = MASTER_DB.orders || [];
        var actualOrders = [];
        
        for (var k = 0; k < orders.length; k++) {
          var orderEmail = getOrderEmail(orders[k]);
          if (orderEmail === customerEmail) {
            actualOrders.push(orders[k]);
          }
        }
        
        console.log('📊 Customer ' + c.email + ': Shopify says ' + (c.orders_count || 0) + ' orders, Found ' + actualOrders.length + ' in MASTER_DB');

        return {
          id: 'ds_' + c.id,
          customerId: c.id,
          name: ((c.first_name || '') + ' ' + (c.last_name || '')).trim() || (c.email && c.email.split('@')[0]) || 'Unknown',
          email: customerEmail,
          phone: c.phone || (c.default_address && c.default_address.phone) || 'N/A',
          ordersCount: actualOrders.length,
          shopifyOrdersCount: c.orders_count,
          lastOrderDate: c.last_order_date,
          spentAED: rawSpent,
          spentUSD: rawSpent / EXCHANGE_RATES.USD,
          brandDiscounts: config.brands,
          defaultDiscount: config.default,
          shippingRules: config.shipping
        };
      });

      console.log('✅ Loaded ' + MODULE.dropshippers.length + ' dropshippers');
      MODULE.hasLoaded = true;
      renderDropshipperUI();
    } catch (err) {
      console.error('Failed to load dropshippers:', err);
    } finally {
      MODULE.isLoading = false;
    }
  }

  // ===========================================================
  // UI RENDERING
  // ===========================================================

  function renderDropshipperUI() {
    var target = document.getElementById('dropshipper-target');
    if (!target) return;

    if (MODULE.dropshippers.length === 0 && !MODULE.hasLoaded) {
      target.innerHTML = '<div class="ds-loading"><div class="ds-loading-icon">⏳</div><h3>Loading Dropshippers...</h3><button class="ds-btn-reload" onclick="forceLoadDropshippers()">🔄 Force Reload</button></div>';
      if (!MODULE.isLoading) loadDropshippers();
      return;
    }

    var options = '';
    for (var i = 0; i < MODULE.dropshippers.length; i++) {
      var ds = MODULE.dropshippers[i];
      options += '<option value="' + ds.id + '">' + ds.name + ' (' + ds.email + ') - ' + ds.ordersCount + ' orders</option>';
    }

    var end = new Date();
    var start = new Date();
    start.setDate(start.getDate() - 365);
    
    var startStr = start.toISOString().split('T')[0];
    var endStr = end.toISOString().split('T')[0];

    target.innerHTML = 
      '<div class="dropshipper-container">' +
        '<div class="ds-stats-grid">' +
          '<div class="ds-stat-card">' +
            '<div class="ds-stat-value">' + MODULE.dropshippers.length + '</div>' +
            '<div class="ds-stat-label">Dropshippers</div>' +
          '</div>' +
          '<div class="ds-stat-card" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white;">' +
            '<div class="ds-stat-value" style="font-size: 18px;">1 USD = ' + EXCHANGE_RATES.USD + ' AED</div>' +
            '<div class="ds-stat-label">Exchange Rate</div>' +
          '</div>' +
        '</div>' +

        '<div class="ds-filter-panel">' +
          '<h3 class="ds-panel-title">🔍 Calculate Commission</h3>' +
          '<div class="ds-form-grid">' +
            '<div class="ds-form-group">' +
              '<label class="ds-form-label">Select Dropshipper *</label>' +
              '<select id="ds-select" class="ds-form-control" onchange="onDropshipperChange()">' +
                '<option value="">-- Select --</option>' + options +
              '</select>' +
            '</div>' +
            '<div class="ds-form-group">' +
              '<label class="ds-form-label">Start Date *</label>' +
              '<input type="date" id="ds-start-date" class="ds-form-control" onchange="previewFilteredData()" value="' + startStr + '">' +
            '</div>' +
            '<div class="ds-form-group">' +
              '<label class="ds-form-label">End Date *</label>' +
              '<input type="date" id="ds-end-date" class="ds-form-control" onchange="previewFilteredData()" value="' + endStr + '">' +
            '</div>' +
            '<div class="ds-form-group">' +
              '<label class="ds-form-label">Status</label>' +
              '<select id="ds-status" class="ds-form-control" onchange="previewFilteredData()">' +
                '<option value="all">All Orders</option>' +
                '<option value="paid" selected>Paid</option>' +
                '<option value="fulfilled">Fulfilled</option>' +
                '<option value="paid_fulfilled">Paid & Fulfilled</option>' +
              '</select>' +
            '</div>' +
          '</div>' +

          '<div id="ds-details-card" style="display: none; border: 1px solid #e5e7eb; border-radius: 8px; padding: 15px; margin-top: 15px; background: #fafafa;">' +
            '<h4 id="ds-detail-name" style="margin-top: 0; color: #1e40af;"></h4>' +
            '<div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 10px;">' +
              '<div>📧 <span id="ds-detail-email"></span></div>' +
              '<div>📱 <span id="ds-detail-phone"></span></div>' +
              '<div>📦 Orders in DB: <strong id="ds-detail-orders" style="color: #059669;"></strong></div>' +
              '<div>📦 Shopify Count: <strong id="ds-detail-shopify-orders" style="color: #6b7280;"></strong></div>' +
              '<div style="grid-column: 1 / -1;">💰 Spent: <span id="ds-detail-spent"></span></div>' +
            '</div>' +
            '<div style="margin: 10px 0;">' +
              '<div style="font-weight: bold; margin-bottom: 5px;">Brand Discounts:</div>' +
              '<div id="ds-detail-brands"></div>' +
            '</div>' +
            '<div id="ds-detail-shipping" style="color: #6b7280; font-size: 0.9em;"></div>' +
            '<div id="ds-preview-data" style="margin-top: 10px;"></div>' +
          '</div>' +

          '<div style="margin-top: 15px;">' +
            '<button onclick="calculateDropshipperReport()" style="background: #3b82f6; color: white; border: none; padding: 10px 20px; border-radius: 6px; cursor: pointer;">📊 Calculate</button>' +
            '<button onclick="exportDropshipperReport(\'pdf\')" id="ds-btn-pdf" style="display: none; background: #ef4444; color: white; border: none; padding: 10px 20px; border-radius: 6px; cursor: pointer; margin-left: 10px;">📄 PDF</button>' +
            '<button onclick="exportDropshipperReport(\'excel\')" id="ds-btn-excel" style="display: none; background: #10b981; color: white; border: none; padding: 10px 20px; border-radius: 6px; cursor: pointer; margin-left: 10px;">📈 Excel</button>' +
            '<button onclick="emailDropshipperReport()" id="ds-btn-email" style="display: none; background: #8b5cf6; color: white; border: none; padding: 10px 20px; border-radius: 6px; cursor: pointer; margin-left: 10px;">📧 Email</button>' +
          '</div>' +
        '</div>' +

        '<div id="ds-results" style="display: none; margin-top: 20px;">' +
          '<div style="background: #f0f9ff; border: 1px solid #bae6fd; border-radius: 8px; padding: 10px; margin-bottom: 15px; text-align: center; color: #0369a1;">' +
            '<strong>💱 Exchange Rate Used:</strong> 1 USD = ' + EXCHANGE_RATES.USD + ' AED' +
          '</div>' +
          
          '<div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 15px; margin-bottom: 20px;">' +
            '<div style="background: white; border: 1px solid #e5e7eb; border-radius: 8px; padding: 15px; text-align: center;">' +
              '<div style="color: #6b7280; font-size: 0.9em;">Total Orders</div>' +
              '<div id="ds-total-orders" style="font-size: 1.5em; font-weight: bold; color: #1e40af;">0</div>' +
            '</div>' +
            '<div style="background: white; border: 1px solid #e5e7eb; border-radius: 8px; padding: 15px; text-align: center;">' +
              '<div style="color: #6b7280; font-size: 0.9em;">Order Value</div>' +
              '<div id="ds-total-value" style="font-size: 1.5em; font-weight: bold; color: #1e40af;">AED 0</div>' +
            '</div>' +
            '<div style="background: white; border: 1px solid #e5e7eb; border-radius: 8px; padding: 15px; text-align: center;">' +
              '<div style="color: #6b7280; font-size: 0.9em;">Retail Cost</div>' +
              '<div id="ds-retail-cost" style="font-size: 1.5em; font-weight: bold; color: #1e40af;">AED 0</div>' +
            '</div>' +
            '<div style="background: white; border: 1px solid #e5e7eb; border-radius: 8px; padding: 15px; text-align: center;">' +
              '<div style="color: #6b7280; font-size: 0.9em;">Discounts</div>' +
              '<div id="ds-total-discount" style="font-size: 1.5em; font-weight: bold; color: #1e40af;">AED 0</div>' +
            '</div>' +
            '<div style="background: white; border: 1px solid #e5e7eb; border-radius: 8px; padding: 15px; text-align: center;">' +
              '<div style="color: #6b7280; font-size: 0.9em;">Shipping</div>' +
              '<div id="ds-your-earnings" style="font-size: 1.5em; font-weight: bold; color: #1e40af;">AED 0</div>' +
            '</div>' +
            '<div style="background: white; border: 1px solid #e5e7eb; border-radius: 8px; padding: 15px; text-align: center;">' +
              '<div style="color: #6b7280; font-size: 0.9em;">DS Profit</div>' +
              '<div id="ds-dropshipper-profit" style="font-size: 1.5em; font-weight: bold; color: #1e40af;">AED 0</div>' +
            '</div>' +
            '<div style="background: white; border: 1px solid #e5e7eb; border-radius: 8px; padding: 15px; text-align: center;">' +
              '<div style="color: #6b7280; font-size: 0.9em;">Your Profit</div>' +
              '<div id="ds-your-profit" style="font-size: 1.5em; font-weight: bold; color: #1e40af;">AED 0</div>' +
            '</div>' +
          '</div>' +

          '<div style="background: white; border: 1px solid #e5e7eb; border-radius: 8px; overflow: hidden;">' +
            '<div style="background: #f3f4f6; padding: 10px; font-weight: bold; border-bottom: 1px solid #e5e7eb;">Order Breakdown</div>' +
            '<div style="overflow-x: auto;">' +
              '<table style="width: 100%; border-collapse: collapse;">' +
                '<thead>' +
                  '<tr style="background: #f9fafb;">' +
                    '<th style="padding: 10px; text-align: left; border-bottom: 1px solid #e5e7eb;">Order #</th>' +
                    '<th style="padding: 10px; text-align: left; border-bottom: 1px solid #e5e7eb;">Date</th>' +
                    '<th style="padding: 10px; text-align: left; border-bottom: 1px solid #e5e7eb;">Product</th>' +
                    '<th style="padding: 10px; text-align: left; border-bottom: 1px solid #e5e7eb;">Brand</th>' +
                    '<th style="padding: 10px; text-align: right; border-bottom: 1px solid #e5e7eb;">Qty</th>' +
                    '<th style="padding: 10px; text-align: right; border-bottom: 1px solid #e5e7eb;">Order Value</th>' +
                    '<th style="padding: 10px; text-align: right; border-bottom: 1px solid #e5e7eb;">Retail</th>' +
                    '<th style="padding: 10px; text-align: right; border-bottom: 1px solid #e5e7eb;">Discount</th>' +
                    '<th style="padding: 10px; text-align: right; border-bottom: 1px solid #e5e7eb;">Shipping</th>' +
                    '<th style="padding: 10px; text-align: right; border-bottom: 1px solid #e5e7eb;">Your Profit</th>' +
                    '<th style="padding: 10px; text-align: right; border-bottom: 1px solid #e5e7eb;">DS Profit</th>' +
                  '</tr>' +
                '</thead>' +
                '<tbody id="ds-orders-table"></tbody>' +
                '<tfoot style="background: #f9fafb; font-weight: bold;">' +
                  '<tr>' +
                    '<td colspan="5" style="padding: 10px; text-align: right; border-top: 2px solid #e5e7eb;">TOTALS:</td>' +
                    '<td id="ds-foot-total" style="padding: 10px; text-align: right; border-top: 2px solid #e5e7eb;">AED 0</td>' +
                    '<td id="ds-foot-retail" style="padding: 10px; text-align: right; border-top: 2px solid #e5e7eb;">AED 0</td>' +
                    '<td id="ds-foot-discount" style="padding: 10px; text-align: right; border-top: 2px solid #e5e7eb;">AED 0</td>' +
                    '<td id="ds-foot-shipping" style="padding: 10px; text-align: right; border-top: 2px solid #e5e7eb;">AED 0</td>' +
                    '<td id="ds-foot-your-profit" style="padding: 10px; text-align: right; border-top: 2px solid #e5e7eb;">AED 0</td>' +
                    '<td id="ds-foot-ds-profit" style="padding: 10px; text-align: right; border-top: 2px solid #e5e7eb;">AED 0</td>' +
                  '</tr>' +
                '</tfoot>' +
              '</table>' +
            '</div>' +
          '</div>' +
        '</div>' +

        '<div id="ds-empty" style="text-align: center; padding: 40px; color: #6b7280;">' +
          '<div style="font-size: 3em; margin-bottom: 10px;">🚚</div>' +
          '<h3>Dropshipper Commission Calculator</h3>' +
          '<p>Select dropshipper and date range to calculate</p>' +
        '</div>' +
      '</div>';
  }

  // ===========================================================
  // EVENT HANDLERS
  // ===========================================================

  window.onDropshipperChange = function() {
    var dsId = document.getElementById('ds-select').value;
    
    MODULE.reportData = null;
    MODULE.currentDropshipperId = dsId;
    
    document.getElementById('ds-results').style.display = 'none';
    document.getElementById('ds-empty').style.display = 'block';
    document.getElementById('ds-btn-pdf').style.display = 'none';
    document.getElementById('ds-btn-excel').style.display = 'none';
    document.getElementById('ds-btn-email').style.display = 'none';
    
    var tbody = document.getElementById('ds-orders-table');
    if (tbody) tbody.innerHTML = '';
    
    showDropshipperDetails();
    previewFilteredData();
  };

  window.showDropshipperDetails = function() {
    var dsId = document.getElementById('ds-select').value;
    var card = document.getElementById('ds-details-card');
    
    if (!dsId) {
      card.style.display = 'none';
      return;
    }

    var ds = null;
    for (var i = 0; i < MODULE.dropshippers.length; i++) {
      if (MODULE.dropshippers[i].id === dsId) {
        ds = MODULE.dropshippers[i];
        break;
      }
    }
    if (!ds) return;

    document.getElementById('ds-detail-name').innerText = ds.name;
    document.getElementById('ds-detail-email').innerText = ds.email;
    document.getElementById('ds-detail-phone').innerText = ds.phone;
    document.getElementById('ds-detail-orders').innerText = ds.ordersCount;
    document.getElementById('ds-detail-shopify-orders').innerText = ds.shopifyOrdersCount || 'N/A';
    
    var formattedUSD = ds.spentUSD.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
    var formattedAED = ds.spentAED.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});

    document.getElementById('ds-detail-spent').innerHTML = 
      '<div style="text-align: left; line-height: 1.3;">' +
        '<div style="font-weight: bold; color: #1e40af;">USD ' + formattedUSD + '</div>' +
        '<div style="font-size: 0.9em; color: #4b5563;">≈ AED ' + formattedAED + ' <small style="color: #9ca3af;">(@ ' + EXCHANGE_RATES.USD + ')</small></div>' +
      '</div>';

    var brandsDiv = document.getElementById('ds-detail-brands');
    var entries = [];
    for (var key in ds.brandDiscounts) {
      if (ds.brandDiscounts.hasOwnProperty(key)) {
        entries.push({brand: key, disc: ds.brandDiscounts[key]});
      }
    }
    
    if (entries.length > 0) {
      var brandsHtml = '';
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        brandsHtml += '<span style="background:#eff6ff;color:#1e40af;padding:2px 8px;border-radius:12px;font-size:12px;margin-right:5px;border:1px solid #bfdbfe;display:inline-block;margin-bottom:4px;">' + e.brand + ': ' + e.disc.value + (e.disc.type === 'percentage' ? '%' : ' AED') + '</span>';
      }
      brandsDiv.innerHTML = brandsHtml;
    } else {
      brandsDiv.innerHTML = '<span style="color: #6b7280;">Default: ' + (ds.defaultDiscount ? ds.defaultDiscount.value : 0) + '%</span>';
    }
    
    var rules = ds.shippingRules || {};
    var shipText = '🚚 ';
    if (rules.useActual) shipText += 'Actual shipping costs';
    else if (rules.freeThreshold > 0) shipText += 'Free above AED ' + rules.freeThreshold;
    else shipText += 'Fixed: AED ' + (rules.defaultCost || 0);
    
    document.getElementById('ds-detail-shipping').innerText = shipText;
    card.style.display = 'block';
  };

  window.previewFilteredData = function() {
    var dsId = document.getElementById('ds-select');
    var startStr = document.getElementById('ds-start-date');
    var endStr = document.getElementById('ds-end-date');
    var status = document.getElementById('ds-status');

    if (!dsId || !startStr || !endStr) return;
    dsId = dsId.value;
    startStr = startStr.value;
    endStr = endStr.value;
    status = status ? status.value : 'all';

    if (!dsId || !startStr || !endStr) return;

    var dropshipper = null;
    for (var i = 0; i < MODULE.dropshippers.length; i++) {
      if (MODULE.dropshippers[i].id === dsId) {
        dropshipper = MODULE.dropshippers[i];
        break;
      }
    }
    if (!dropshipper) return;

    var start = new Date(startStr);
    start.setHours(0, 0, 0, 0);
    var end = new Date(endStr);
    end.setHours(23, 59, 59, 999);

    console.log('🔍 Searching orders for: ' + dropshipper.email);
    console.log('📅 Date range: ' + start.toISOString() + ' to ' + end.toISOString());

    var allOrdersForCustomer = [];
    var orders = MASTER_DB.orders || [];
    
    for (var j = 0; j < orders.length; j++) {
      var orderEmail = getOrderEmail(orders[j]);
      if (orderEmail === dropshipper.email) {
        allOrdersForCustomer.push(orders[j]);
      }
    }

    var filtered = [];
    for (var m = 0; m < allOrdersForCustomer.length; m++) {
      var o = allOrdersForCustomer[m];
      var orderDate = new Date(o.created_at);
      var dateMatch = orderDate >= start && orderDate <= end;
      
      var statusMatch = true;
      if (status === 'paid') statusMatch = o.financial_status === 'paid';
      else if (status === 'fulfilled') statusMatch = o.fulfillment_status === 'fulfilled';
      else if (status === 'paid_fulfilled') statusMatch = o.financial_status === 'paid' && o.fulfillment_status === 'fulfilled';
      
      if (dateMatch && statusMatch) filtered.push(o);
    }

    var totalItems = 0;
    var totalValue = 0;
    for (var n = 0; n < filtered.length; n++) {
      totalItems += (filtered[n].line_items && filtered[n].line_items.length) || 0;
      totalValue += convertToAED(filtered[n].total_price, getOrderCurrency(filtered[n]));
    }

    var previewDiv = document.getElementById('ds-preview-data');
    if (previewDiv) {
      if (filtered.length === 0) {
        if (allOrdersForCustomer.length === 0) {
          previewDiv.innerHTML = 
            '<div style="margin-top:15px;padding:15px;background:#fef2f2;border-radius:6px;border:1px solid #fecaca;color:#991b1b;text-align:center;">' +
              '<div style="margin-bottom:10px;"><strong>⚠️ No orders found in local database!</strong></div>' +
              '<button onclick="window.syncDropshipperFromShopify()" ' +
                'style="background:#dc2626;color:white;border:none;padding:8px 16px;border-radius:6px;cursor:pointer;font-weight:600;">' +
                '🔄 Sync from Shopify Now' +
              '</button>' +
            '</div>';
        } else {
          previewDiv.innerHTML = 
            '<div style="margin-top:15px;padding:10px;background:#fef2f2;border-radius:6px;border:1px solid #fecaca;color:#991b1b;">' +
              '<strong>⚠️ No orders found in selected date range!</strong><br>' +
              '<small>This customer has ' + allOrdersForCustomer.length + ' total orders in database.<br>' +
              'Date range: ' + start.toLocaleDateString() + ' to ' + end.toLocaleDateString() + '</small>' +
            '</div>';
        }
      } else {
        previewDiv.innerHTML = 
          '<div style="margin-top:15px;padding:10px;background:#f0f9ff;border-radius:6px;border:1px solid #bae6fd;">' +
            '<strong>📊 Preview:</strong> ' + filtered.length + ' orders, ' + totalItems + ' items, ' + formatPrice(totalValue) +
            '<button onclick="window.syncDropshipperFromShopify()" style="margin-left:10px;background:#3b82f6;color:white;border:none;padding:4px 8px;border-radius:4px;cursor:pointer;font-size:12px;">🔄 Refresh from Shopify</button>' +
          '</div>';
      }
    }
  };

  // ===========================================================
  // REPORT CALCULATION
  // ===========================================================

  window.calculateDropshipperReport = function() {
    var dsId = document.getElementById('ds-select').value;
    var startStr = document.getElementById('ds-start-date').value;
    var endStr = document.getElementById('ds-end-date').value;
    var status = document.getElementById('ds-status').value || 'all';

    if (!dsId || !startStr || !endStr) {
      alert('Please select dropshipper and date range');
      return;
    }

    var dropshipper = null;
    for (var i = 0; i < MODULE.dropshippers.length; i++) {
      if (MODULE.dropshippers[i].id === dsId) {
        dropshipper = MODULE.dropshippers[i];
        break;
      }
    }
    if (!dropshipper) {
      alert('Dropshipper not found');
      return;
    }

    var start = new Date(startStr);
    start.setHours(0, 0, 0, 0);
    var end = new Date(endStr);
    end.setHours(23, 59, 59, 999);

    var customerOrders = [];
    var allOrders = MASTER_DB.orders || [];
    
    for (var j = 0; j < allOrders.length; j++) {
      var orderEmail = getOrderEmail(allOrders[j]);
      if (orderEmail === dropshipper.email) {
        customerOrders.push(allOrders[j]);
      }
    }

    var orders = [];
    for (var k = 0; k < customerOrders.length; k++) {
      var o = customerOrders[k];
      var orderDate = new Date(o.created_at);
      if (orderDate < start || orderDate > end) continue;
      
      if (status === 'paid') {
        if (o.financial_status !== 'paid') continue;
      } else if (status === 'fulfilled') {
        if (o.fulfillment_status !== 'fulfilled') continue;
      } else if (status === 'paid_fulfilled') {
        if (o.financial_status !== 'paid' || o.fulfillment_status !== 'fulfilled') continue;
      }
      orders.push(o);
    }

    if (!orders.length) {
      alert('No orders found for ' + dropshipper.name + ' in selected date range.\n\nTotal in database: ' + customerOrders.length + ' orders');
      return;
    }

    var items = [];
    var totalShipping = 0;

    for (var m = 0; m < orders.length; m++) {
      var order = orders[m];
      var shipping = calculateShipping(order, dropshipper);
      totalShipping += shipping.cost;
      
      var lineItems = order.line_items || [];
      var orderCurrency = getOrderCurrency(order);
      
      for (var p = 0; p < lineItems.length; p++) {
        var item = lineItems[p];
        
        var product = null;
        var variant = null;
        
        if (MASTER_DB.products) {
          for (var q = 0; q < MASTER_DB.products.length; q++) {
            var prod = MASTER_DB.products[q];
            if (prod.variants) {
              for (var r = 0; r < prod.variants.length; r++) {
                if (prod.variants[r].id == item.variant_id) {
                  product = prod;
                  variant = prod.variants[r];
                  break;
                }
              }
            }
            if (variant) break;
          }
        }
        
        var brand = item.vendor || (product && product.vendor) || 'Unknown';
        var discount = getBrandDiscount(dropshipper, brand);
        
        var qty = item.quantity || 1;
        var itemPrice = convertToAED(item.price, orderCurrency);
        var retailPrice = parseFloat((variant && variant.price) || item.price);
        
        var itemTotal = itemPrice * qty;
        var retailTotal = retailPrice * qty;
        
        var discountAmt = 0;
        if (discount.type === 'percentage') {
          discountAmt = retailTotal * (discount.value / 100);
        } else {
          discountAmt = discount.value * qty;
        }
        
        var yourProfit = (retailTotal - discountAmt);
        var dsProfit = itemTotal - (retailTotal - discountAmt);

        items.push({
          order: order,
          item: item,
          brand: brand,
          qty: qty,
          itemTotal: itemTotal,
          retailTotal: retailTotal,
          discountAmt: discountAmt,
          yourProfit: yourProfit,
          dsProfit: dsProfit,
          discount: discount,
          orderShipping: shipping.cost,
          orderCurrency: orderCurrency
        });
      }
    }

    var totals = {
      orders: orders.length,
      items: items.length,
      orderValue: 0,
      retailCost: 0,
      discount: 0,
      shipping: totalShipping,
      yourProfit: 0,
      dsProfit: 0
    };
    
    for (var s = 0; s < items.length; s++) {
      totals.orderValue += items[s].itemTotal;
      totals.retailCost += items[s].retailTotal;
      totals.discount += items[s].discountAmt;
      totals.yourProfit += items[s].yourProfit;
      totals.dsProfit += items[s].dsProfit;
    }
    
    totals.yourProfit += totalShipping;
    totals.dsProfit -= totalShipping;

    MODULE.reportData = { dropshipper: dropshipper, start: start, end: end, items: items, totals: totals, totalShipping: totalShipping };
    displayResults(MODULE.reportData);
  };

  function displayResults(report) {
    document.getElementById('ds-empty').style.display = 'none';
    document.getElementById('ds-results').style.display = 'block';
    document.getElementById('ds-btn-pdf').style.display = 'inline-flex';
    document.getElementById('ds-btn-excel').style.display = 'inline-flex';
    document.getElementById('ds-btn-email').style.display = 'inline-flex';

    document.getElementById('ds-total-orders').innerText = report.totals.orders;
    document.getElementById('ds-total-value').innerText = formatPrice(report.totals.orderValue);
    document.getElementById('ds-retail-cost').innerText = formatPrice(report.totals.retailCost);
    document.getElementById('ds-total-discount').innerText = formatPrice(report.totals.discount);
    document.getElementById('ds-your-earnings').innerText = formatPrice(report.totals.shipping);
    document.getElementById('ds-dropshipper-profit').innerText = formatPrice(report.totals.dsProfit);
    document.getElementById('ds-your-profit').innerText = formatPrice(report.totals.yourProfit);

    var grouped = {};
    for (var i = 0; i < report.items.length; i++) {
      var item = report.items[i];
      var id = item.order.name;
      if (!grouped[id]) {
        grouped[id] = { 
          order: item.order, 
          items: [], 
          orderShipping: item.orderShipping,
          totals: { qty: 0, subtotal: 0, retail: 0, discount: 0, dsProfit: 0, yourProfit: 0 }
        };
      }
      grouped[id].items.push(item);
      grouped[id].totals.qty += item.qty;
      grouped[id].totals.subtotal += item.itemTotal;
      grouped[id].totals.retail += item.retailTotal;
      grouped[id].totals.discount += item.discountAmt;
      grouped[id].totals.dsProfit += item.dsProfit;
      grouped[id].totals.yourProfit += item.yourProfit;
    }

    var tbody = document.getElementById('ds-orders-table');
    var html = '';

    var orderIds = Object.keys(grouped);
    for (var j = 0; j < orderIds.length; j++) {
      var orderId = orderIds[j];
      var group = grouped[orderId];
      var order = group.order;
      var date = new Date(order.created_at).toLocaleDateString('en-GB');
      var safeClass = orderId.replace(/[^a-zA-Z0-9]/g, '_');
      
      var orderYourProfit = group.totals.yourProfit + group.orderShipping;
      var orderDSProfit = group.totals.dsProfit - group.orderShipping;

      html += 
        '<tr onclick="toggleOrderItems(\'' + safeClass + '\')" style="cursor:pointer;background:#f8fafc;">' +
          '<td style="padding: 10px; border-bottom: 1px solid #e5e7eb;"><span id="toggle-' + safeClass + '">▼</span> <a href="https://' + (window.Shopify && window.Shopify.shop ? window.Shopify.shop : '') + '/admin/orders/' + order.id + '" target="_blank" style="color: #3b82f6; text-decoration: none;">' + orderId + '</a></td>' +
          '<td style="padding: 10px; border-bottom: 1px solid #e5e7eb;">' + date + '</td>' +
          '<td style="padding: 10px; border-bottom: 1px solid #e5e7eb;" colspan="2"><strong>📦 ' + group.items.length + ' Items</strong></td>' +
          '<td style="padding: 10px; border-bottom: 1px solid #e5e7eb; text-align: right;"><strong>' + group.totals.qty + '</strong></td>' +
          '<td style="padding: 10px; border-bottom: 1px solid #e5e7eb; text-align: right;"><strong>' + formatPrice(group.totals.subtotal) + '</strong></td>' +
          '<td style="padding: 10px; border-bottom: 1px solid #e5e7eb; text-align: right;">' + formatPrice(group.totals.retail) + '</td>' +
          '<td style="padding: 10px; border-bottom: 1px solid #e5e7eb; text-align: right;">-' + formatPrice(group.totals.discount) + '</td>' +
          '<td style="padding: 10px; border-bottom: 1px solid #e5e7eb; text-align: right; color: #dc2626; font-weight: bold;">- ' + formatPrice(group.orderShipping) + '</td>' +
          '<td style="padding: 10px; border-bottom: 1px solid #e5e7eb; text-align: right;"><strong style="color: #059669;">' + formatPrice(orderYourProfit) + '</strong></td>' +
          '<td style="padding: 10px; border-bottom: 1px solid #e5e7eb; text-align: right;"><strong>' + formatPrice(orderDSProfit) + '</strong></td>' +
        '</tr>';

      for (var k = 0; k < group.items.length; k++) {
        var item = group.items[k];
        var indent = (k === group.items.length - 1) ? '└─' : '├─';
        var bgColor = (j % 2 === 0) ? '#ffffff' : '#fafafa';
        var dsProfitColor = item.dsProfit < 0 ? '#dc2626' : '#059669';
        
        html += 
          '<tr class="order-item-' + safeClass + '" style="background:' + bgColor + ';font-size:0.9em;">' +
            '<td style="padding: 8px 10px 8px 30px; border-bottom: 1px solid #f3f4f6; color:#6b7280;">' + indent + ' ' + (k + 1) + '</td>' +
            '<td style="padding: 8px 10px; border-bottom: 1px solid #f3f4f6;"></td>' +
            '<td style="padding: 8px 10px; border-bottom: 1px solid #f3f4f6;">' + (item.item.title.length > 40 ? item.item.title.substring(0, 40) + '...' : item.item.title) + '</td>' +
            '<td style="padding: 8px 10px; border-bottom: 1px solid #f3f4f6;"><span style="background:#e0e7ff;color:#3730a3;padding:2px 6px;border-radius:4px;font-size:11px;">' + item.brand + '</span></td>' +
            '<td style="padding: 8px 10px; border-bottom: 1px solid #f3f4f6; text-align: right;">' + item.qty + '</td>' +
            '<td style="padding: 8px 10px; border-bottom: 1px solid #f3f4f6; text-align: right;">' + formatPrice(item.itemTotal) + '</td>' +
            '<td style="padding: 8px 10px; border-bottom: 1px solid #f3f4f6; text-align: right;">' + formatPrice(item.retailTotal) + '</td>' +
            '<td style="padding: 8px 10px; border-bottom: 1px solid #f3f4f6; text-align: right;">-' + formatPrice(item.discountAmt) + ' <small style="color:#6b7280;">(' + item.discount.value + (item.discount.type === 'percentage' ? '%' : ' AED') + ')</small></td>' +
            '<td style="padding: 8px 10px; border-bottom: 1px solid #f3f4f6; text-align: right; color:#9ca3af;">-</td>' +
            '<td style="padding: 8px 10px; border-bottom: 1px solid #f3f4f6; text-align: right;">' + formatPrice(item.yourProfit) + '</td>' +
            '<td style="padding: 8px 10px; border-bottom: 1px solid #f3f4f6; text-align: right; color:' + dsProfitColor + ';">' + formatPrice(item.dsProfit) + '</td>' +
          '</tr>';
      }
    }

    tbody.innerHTML = html;

    document.getElementById('ds-foot-total').innerText = formatPrice(report.totals.orderValue);
    document.getElementById('ds-foot-retail').innerText = formatPrice(report.totals.retailCost);
    document.getElementById('ds-foot-discount').innerText = formatPrice(report.totals.discount);
    document.getElementById('ds-foot-shipping').innerText = formatPrice(report.totals.shipping);
    document.getElementById('ds-foot-your-profit').innerText = formatPrice(report.totals.yourProfit);
    document.getElementById('ds-foot-ds-profit').innerText = formatPrice(report.totals.dsProfit);
  }

  window.toggleOrderItems = function(orderClass) {
    var rows = document.querySelectorAll('.order-item-' + orderClass);
    var icon = document.getElementById('toggle-' + orderClass);
    if (!rows.length) return;
    
    var isHidden = rows[0].style.display === 'none';
    for (var i = 0; i < rows.length; i++) {
      rows[i].style.display = isHidden ? '' : 'none';
    }
    if (icon) icon.innerText = isHidden ? '▼' : '▶';
  };

  // ===========================================================
  // EXPORTS
  // ===========================================================

  window.exportDropshipperReport = function(type) {
    var report = MODULE.reportData;
    if (!report) {
      alert('Calculate report first!');
      return;
    }
    
    if (type === 'pdf') {
      generatePDF(report);
    } else {
      generateExcel(report);
    }
  };

  function generatePDF(report) {
    var jsPDF = window.jspdf.jsPDF;
    var doc = new jsPDF('l', 'mm', 'a4');
    var ds = report.dropshipper;
    
    doc.setFontSize(16);
    doc.setTextColor(37, 99, 235);
    doc.text('Dropshipper Commission Report', 14, 15);
    
    doc.setFontSize(11);
    doc.setTextColor(100);
    doc.text('Dropshipper: ' + ds.name, 14, 25);
    doc.text('Email: ' + ds.email, 14, 32);
    doc.text('Period: ' + report.start.toLocaleDateString() + ' to ' + report.end.toLocaleDateString(), 14, 39);
    doc.text('Exchange Rate: 1 USD = ' + EXCHANGE_RATES.USD + ' AED', 14, 46);

    var head = [['Order', 'Date', 'Product', 'Brand', 'Qty', 'Value', 'Retail', 'Disc', 'Ship', 'Your Profit', 'DS Profit']];
    var body = [];
    
    for (var i = 0; i < report.items.length; i++) {
      var item = report.items[i];
      body.push([
        item.order.name,
        new Date(item.order.created_at).toLocaleDateString(),
        item.item.title.substring(0, 20),
        item.brand,
        item.qty,
        formatPrice(item.itemTotal),
        formatPrice(item.retailTotal),
        formatPrice(item.discountAmt),
        formatPrice(item.orderShipping || 0),
        formatPrice(item.yourProfit),
        formatPrice(item.dsProfit)
      ]);
    }

    doc.autoTable({
      startY: 55,
      head: head,
      body: body,
      theme: 'striped',
      headStyles: { fillColor: [37, 99, 235], textColor: 255, fontSize: 8 },
      bodyStyles: { fontSize: 7 },
      foot: [['', '', '', '', 'TOTAL', formatPrice(report.totals.orderValue), formatPrice(report.totals.retailCost), formatPrice(report.totals.discount), formatPrice(report.totals.shipping), formatPrice(report.totals.yourProfit), formatPrice(report.totals.dsProfit)]],
      footStyles: { fillColor: [241, 245, 249], fontStyle: 'bold' }
    });

    doc.save('DS_Report_' + ds.name + '_' + Date.now() + '.pdf');
  }

  function generateExcel(report) {
    var ds = report.dropshipper;
    var csv = "data:text/csv;charset=utf-8,";
    
    csv += "Dropshipper Commission Report\n";
    csv += "Dropshipper," + ds.name + "\n";
    csv += "Email," + ds.email + "\n";
    csv += "Period," + report.start.toLocaleDateString() + " to " + report.end.toLocaleDateString() + "\n";
    csv += "Exchange Rate,1 USD = " + EXCHANGE_RATES.USD + " AED\n\n";
    
    csv += "SUMMARY\n";
    csv += "Orders," + report.totals.orders + "\n";
    csv += "Items," + report.totals.items + "\n";
    csv += "Order Value," + report.totals.orderValue + "\n";
    csv += "Retail Cost," + report.totals.retailCost + "\n";
    csv += "Discounts," + report.totals.discount + "\n";
    csv += "Shipping," + report.totals.shipping + "\n";
    csv += "Your Profit," + report.totals.yourProfit + "\n";
    csv += "DS Profit," + report.totals.dsProfit + "\n\n";
    
    csv += "DETAILS\n";
    csv += "Order,Date,Product,Brand,Qty,Order Total,Retail,Discount,Shipping,Your Profit,DS Profit\n";
    
    for (var i = 0; i < report.items.length; i++) {
      var item = report.items[i];
      csv += item.order.name + "," + new Date(item.order.created_at).toLocaleDateString() + ",\"" + item.item.title.replace(/"/g, '""') + "\"," + item.brand + "," + item.qty + "," + item.itemTotal + "," + item.retailTotal + "," + item.discountAmt + "," + (item.orderShipping || 0) + "," + item.yourProfit + "," + item.dsProfit + "\n";
    }

    var link = document.createElement("a");
    link.setAttribute("href", encodeURI(csv));
    link.setAttribute("download", "DS_Report_" + ds.name + "_" + Date.now() + ".csv");
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  window.emailDropshipperReport = function() {
    var report = MODULE.reportData;
    if (!report) {
      alert('Calculate report first!');
      return;
    }

    var ds = report.dropshipper;
    if (!confirm('Send report to ' + ds.name + ' at ' + ds.email + '?')) return;

    var jsPDF = window.jspdf.jsPDF;
    var doc = new jsPDF();
    
    doc.setFontSize(16);
    doc.text('Dropshipper Commission Report', 14, 20);
    doc.setFontSize(12);
    doc.text('Dropshipper: ' + ds.name, 14, 35);
    doc.text('Period: ' + report.start.toLocaleDateString() + ' to ' + report.end.toLocaleDateString(), 14, 45);
    doc.text('Exchange Rate: 1 USD = ' + EXCHANGE_RATES.USD + ' AED', 14, 55);
    doc.text('Total Orders: ' + report.totals.orders, 14, 70);
    doc.text('Order Value: ' + formatPrice(report.totals.orderValue), 14, 80);
    doc.text('Your Commission: ' + formatPrice(report.totals.dsProfit), 14, 90);
    
    var pdfBase64 = doc.output('datauristring').split(',')[1];

    fetch((window.SYSTEM && window.SYSTEM.BRIDGE) || '', {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({
        auth_key: (window.SYSTEM && window.SYSTEM.AUTH) || '',
        endpoint: '/send_dropshipper_report',
        data: { dropshipper: ds, report: report, pdfBase64: pdfBase64 }
      })
    })
    .then(function(res) { return res.json(); })
    .then(function(result) {
      if (result.status === "success") {
        alert('✅ Report sent to ' + ds.email + '!');
      } else {
        throw new Error(result.message);
      }
    })
    .catch(function(e) {
      console.error("Email error:", e);
      alert("Failed to send email. Please download and send manually.");
    });
  };

  // ===========================================================
  // SHOPIFY SYNC - USE CUSTOMER ID
  // ===========================================================

  window.syncDropshipperFromShopify = async function() {
    var dsId = MODULE.currentDropshipperId;
    if (!dsId) {
      alert('Please select a dropshipper first');
      return;
    }

    var dropshipper = null;
    for (var i = 0; i < MODULE.dropshippers.length; i++) {
      if (MODULE.dropshippers[i].id === dsId) {
        dropshipper = MODULE.dropshippers[i];
        break;
      }
    }
    
    if (!dropshipper) {
      alert('Dropshipper not found');
      return;
    }

    var btn = event.target;
    var originalText = btn.innerHTML;
    btn.innerHTML = '⏳ Syncing...';
    btn.disabled = true;

    try {
      console.log('🔄 Starting sync for customer ID:', dropshipper.customerId);
      
      // Use Customer Orders API
      var orders = await fetchCustomerOrders(dropshipper.customerId);
      
      if (orders.length === 0) {
        alert('ℹ️ No orders found in Shopify for this customer');
        btn.innerHTML = originalText;
        btn.disabled = false;
        return;
      }
      
      console.log('📥 Fetched ' + orders.length + ' orders from Shopify');
      
      var result = mergeOrdersToMasterDB(orders);
      
      // Update count
      var allOrders = MASTER_DB.orders || [];
      var customerOrders = [];
      for (var j = 0; j < allOrders.length; j++) {
        if (getOrderEmail(allOrders[j]) === dropshipper.email) {
          customerOrders.push(allOrders[j]);
        }
      }
      dropshipper.ordersCount = customerOrders.length;
      
      showDropshipperDetails();
      previewFilteredData();
      
      alert('✅ Sync complete!\n\nNew orders: ' + result.added + '\nUpdated: ' + result.updated + '\nTotal in DB: ' + customerOrders.length);
      
    } catch (error) {
      console.error('Sync error:', error);
      alert('❌ Sync failed: ' + error.message);
    } finally {
      btn.innerHTML = originalText;
      btn.disabled = false;
    }
  };

  async function fetchCustomerOrders(customerId) {
    var endpoint = '/customers/' + customerId + '/orders.json?limit=250';
    
    console.log('🌐 API Call:', endpoint);
    
    var response = await fetch(SYSTEM.BRIDGE, {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({
        auth_key: SYSTEM.AUTH,
        endpoint: endpoint,
        method: 'GET'
      })
    });
    
    var data = await response.json();
    
    if (data.errors) {
      throw new Error(JSON.stringify(data.errors));
    }
    
    var orders = data.orders || [];
    console.log('✅ API returned', orders.length, 'orders for customer', customerId);
    
    for (var i = 0; i < orders.length; i++) {
      console.log('  - Order #' + orders[i].name + ' | Date: ' + orders[i].created_at + ' | Total: ' + orders[i].total_price);
    }
    
    return orders;
  }

  function mergeOrdersToMasterDB(newOrders) {
    if (!MASTER_DB.orders) MASTER_DB.orders = [];
    
    var added = 0;
    var updated = 0;
    
    for (var i = 0; i < newOrders.length; i++) {
      var newOrder = newOrders[i];
      var exists = false;
      var existingIndex = -1;
      
      for (var j = 0; j < MASTER_DB.orders.length; j++) {
        if (MASTER_DB.orders[j].id == newOrder.id) {
          exists = true;
          existingIndex = j;
          break;
        }
      }
      
      if (!exists) {
        MASTER_DB.orders.push(newOrder);
        added++;
      } else if (new Date(newOrder.updated_at) > new Date(MASTER_DB.orders[existingIndex].updated_at)) {
        MASTER_DB.orders[existingIndex] = newOrder;
        updated++;
      }
    }
    
    console.log('💾 Merged to DB - Added:', added, 'Updated:', updated);
    return { added: added, updated: updated };
  }

  // ===========================================================
  // INITIALIZATION
  // ===========================================================

  window.initDropshipperModule = function() {
    console.log('Init dropshipper module');
    
    if (!MODULE.hasLoaded && !MODULE.isLoading) {
      loadDropshippers();
    } else {
      renderDropshipperUI();
    }
  };

  window.forceLoadDropshippers = function() {
    MODULE.hasLoaded = false;
    MODULE.dropshippers = [];
    loadDropshippers();
  };

})();